import React, { Fragment } from "react";

import { Typography } from "@material-ui/core";

import { default as BaseModal } from "@ds-developer/modal";
import Button from "@ds-developer/button";

import { DiscardPromptModalProps } from "./types";

const DiscardPromptModal: React.FC<DiscardPromptModalProps> = ({
  onCancelClick = () => {},
  onConfirmClick = () => {},
}) => {
  const actions = (
    <Fragment>
      <Button
        onClick={onCancelClick}
        variant="outlined"
        data-test="discard-modal-cancel-button"
      >
        Cancel
      </Button>
      <Button
        onClick={onConfirmClick}
        type="submit"
        variant="contained"
        color="error"
        data-test="discard-modal-confirm-button"
      >
        Yes, Discard
      </Button>
    </Fragment>
  );

  return (
    <BaseModal
      actions={actions}
      open
      title="Discard changes"
      data-test="discard-prompt-modal"
    >
      <Typography data-test="discard-prompt-modal-text">
        Are you sure you would like to discard your changes?
      </Typography>
    </BaseModal>
  );
};

export default DiscardPromptModal;
